import {
  ApiAIImageGenerationBackend,
  ApiBilling,
} from "@incendium/api";
import { aiService } from "Apis";

export interface GenerateImageParams {
  prompt: string;
  backend: ApiAIImageGenerationBackend;
  size: string;
  aspectRatio: string;
}

export const generateImage = async (
  projectId: number,
  params: GenerateImageParams
): Promise<string> => {
  const res = await aiService.aiServiceGenerateImage({
    projectId,
    body: {
      prompt: params.prompt,
      backend: params.backend,
      size: params.size,
      aspectRatio: params.aspectRatio,
    },
  });
  return res.res ?? "";
};

export interface EditImageParams {
  prompt: string;
  url: string;
  backend: ApiAIImageGenerationBackend;
}

export const editImage = async (
  projectId: number,
  params: EditImageParams
): Promise<string> => {
  const res = await aiService.aiServiceEditImage({
    projectId,
    body: {
      prompt: params.prompt,
      url: params.url,
      backend: params.backend,
    },
  });
  return res.res ?? "";
};

export const listAISessions = async (projectId: number) => {
  const res = await aiService.aiServiceListSessions({
    projectId: projectId,
  });
  return res;
};

export const deleteAISession = async (projectId: number, sessionId: string) => {
  const res = await aiService.aiServiceDeleteSession({
    projectId: projectId,
    sessionId: sessionId,
  });
  return res;
};

export const listBilling = async (): Promise<ApiBilling[]> => {
  const res = await aiService.aiServiceListBilling({});
  return res.billings ?? [];
};

export const createBilling = async (payload: ApiBilling): Promise<ApiBilling> => {
  const res = await aiService.aiServiceCreateBilling({ payload });
  return res;
};

export const listPromptBilling = async (
  projectId: number,
  from?: Date,
  to?: Date
) => {
  const res = await aiService.aiServiceListPromptBilling({
    projectId,
    from,
    to,
  });
  return res.prompts ?? [];
};